import { render, staticRenderFns } from "./SelectBoxQuestion.vue?vue&type=template&id=bda7a29c&scoped=true"
import script from "./SelectBoxQuestion.vue?vue&type=script&lang=js"
export * from "./SelectBoxQuestion.vue?vue&type=script&lang=js"
import style0 from "./SelectBoxQuestion.vue?vue&type=style&index=0&id=bda7a29c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda7a29c",
  null
  
)

export default component.exports